import { getRegionalData } from "./CommonUtils";

export const getFlightCabSyncHttpData = async (url, headers, method, body, data) => {
  const mcid = data?.dvid;
  const deviceId = data?.dvid;
  const localeSettings = getRegionalData(data);
  let headersMap = { ...headers };
  const devId = "device-id";
  const appVer = "app-ver";
  if (headers == null) {
    headersMap = {
      CONTENT_ENCODING: "gzip",
      CONTENT_TYPE: "application/json",
      src: "mmt",
      mcid,
      pfm: "DESKTOP",
      region: localeSettings.region || "in",
      os: "Mac OS",
    };
    headersMap[devId] = deviceId;
    headersMap[appVer] = "1.0.0";
  }
  const options = {
    method,
    headers: headersMap,
    body,
  };
  const resp = await fetch(url, options).then((res) => res.json());
  return resp;
};

export const getSyncHttpData = async (url, headers, method, body) => {
  let headersMap = { ...headers };
  if (!headersMap) {
    headersMap = {
      CONTENT_ENCODING: "gzip",
      CONTENT_TYPE: "application/json",
    };
  }
  const timeout = 10000;

  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);
  const options = {
    method,
    headers: headersMap,
    body,
  };
  // eslint-disable-next-line no-console
  const resp = await fetch(url, { ...options, signal: controller.signal })
    .then((res) => res.json())
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('errorFetchApi:', url, error);
    });
  clearTimeout(id);
  return resp;
};

export const getAsyncHttpData = async (url, headers, method, body) => {
  let headersMap = { ...headers };
  if (!headersMap) {
    headersMap = {
      CONTENT_ENCODING: "gzip",
      CONTENT_TYPE: "application/json",
    };
  }
  const options = {
    method,
    headers: headersMap,
    body,
  };

  const resp = fetch(url, options).catch((error) => {
    // eslint-disable-next-line no-console
    console.error('errorFetchAsync:', url, error);
  });
  return resp;
};

export async function getHttpBodyHeader(url, headers, method, body) {
  const headersMap = { ...headers };
  try {
    const options = {
      method,
      headers: headersMap,
      body,
    };
    const response = await fetch(url, options);
    const responseBody = await response.json();

    // Return status code, headers, and body
    return {
      status: response.status,
      headers: response.headers,
      body: responseBody,
    };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error making HTTP request to:', url, error);
    throw error;
  }
}
